//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObject.js";
let d=[[[0,"DescriptorCharxType",1,0],[0,"DescriptorSourceType",1,0],[0,"Expression",1,0],[0,"Locked",1,0],[0,"Title",1,0],[0,"Unit",1,0]],[],[]];
SPLM.Routing.RoutePartDescriptor = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.RoutePartDescriptor";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.RoutePartDescriptor.SourceType = Object.freeze({
    "Null" : "Null", "PartAttribute" : "PartAttribute", "Expression" : "Expression", "DumbCopy" : "DumbCopy"});

SPLM.Routing.RoutePartDescriptor.CharxType = Object.freeze({
    "Int" : "Int", "Real" : "Real", "Sting" : "Sting", "Any" : "Any", "Ref" : "Ref", "AnyRef" : "AnyRef"});

export default SPLM;